import { render } from "./NoDataCentralBox.vue?vue&type=template&id=7816d427"
const script = {}

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__